import React from 'react'
import '../Styles/gallery.css'

import foto1 from "../Assets/envases/envase.jpg"
import foto2 from "../Assets/envases/envase1.jpg"
import foto3 from "../Assets/envases/envase2.jpg"
import foto4 from "../Assets/envases/envase3.jpg"


const Gallery = () => {
    return (
        <div className="gal">
            <h1 className="titulo">ENVASES ALIMENTICIOS </h1>
            <div className="galeria" id="ENVASES">
                <a href="#imagene1">
                    <img src={foto1} alt=""/>
                </a>
                <a href="#imagene2">
                    <img src={foto2} alt=""/>
                </a>
                <a href="#imagene3">
                    <img src={foto3} alt=""/>
                </a>
                <a href="#imagene4">
                    <img src={foto4} alt=""/>
                </a>
            </div>

            <div className="light-box" id="imagene1">  
                <a href="#imagene5" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto1} alt=""/>
                <a href="#imagene2" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close" >
                    X 
                </a>
            </div>

            <div className="light-box" id="imagene2">  
                <a href="#imagene1" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto2} alt=""/>
                <a href="#imagene3" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>

            <div className="light-box" id="imagene3">  
                <a href="#imagene2" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto3} alt=""/>
                <a href="#imagene4" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>

            <div className="light-box" id="imagene4">  
                <a href="#imagene3" className="next">
                    <i className="fas fa-arrow-left"></i>
                </a>
                <img src={foto4} alt=""/>
                <a href="#imagene1" className="next">
                    <i className="fas fa-arrow-right"></i>
                </a>
                <a href="#GALERIA" className="close">
                    X
                </a>
            </div>


        </div>
    )
}

export default Gallery
